import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrainListAlarmIconsComponent } from './train-list-alarm-icons/train-list-alarm-icons.component';
import { TechnicalAlarmItemComponent } from './technical-alarm-item/technical-alarm-item.component';
import { TranslateModule } from '@ngx-translate/core';
import { QmDirectivesModule } from '../../../components/qm-directives/qm-directives.module';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TrainAlarmActionsComponent } from './train-alarm-actions/train-alarm-actions.component';
import { ConflictAlarmListItemComponent } from './conflict-alarm-list-item/conflict-alarm-list-item.component';
import { GeneralTrainAlarmListItemComponent } from './general-train-alarm-list-item/general-train-alarm-list-item.component';
import { TrainListAlarmComponent } from './train-list-alarm/train-list-alarm.component';
import { FontAwesomeIconsModule } from '../../../fontawesome-icons.module';
import { QmPipesModule } from '../../../components/qm-pipes/qm-pipes.module';


@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    QmDirectivesModule,
    QmPipesModule,
    NgbTooltipModule,
    FontAwesomeIconsModule
  ],
  declarations: [
    TechnicalAlarmItemComponent,
    TrainListAlarmIconsComponent,
    TrainAlarmActionsComponent,
    ConflictAlarmListItemComponent,
    GeneralTrainAlarmListItemComponent,
    TrainListAlarmComponent
  ],
  exports: [
    TechnicalAlarmItemComponent,
    TrainListAlarmIconsComponent,
    TrainAlarmActionsComponent,
    ConflictAlarmListItemComponent,
    GeneralTrainAlarmListItemComponent,
    TrainListAlarmComponent
  ]
})
export class TrainListAlarmModule { }
